import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Text } from '@chakra-ui/react';
import { Checkbox, Icon, Info } from '@whitbread-eos/atoms';
import { formatDataTestId } from '@whitbread-eos/utils';
import dynamic from 'next/dynamic';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Tooltip = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('@whitbread-eos/atoms'),
    Tooltip = _yield$import.Tooltip;
  return {
    default: Tooltip
  };
}), {
  ssr: false
});
export function createCheckboxList(baseDataTestId, selectedFilters, handleFilterChange, items, liftInfoMessage) {
  var isDlp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var labelTypography = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  function isSRHotelFilter(item) {
    return 'code' in item;
  }
  var LIFT_ACCESS_CODE = isDlp ? 'LFT,HUL' : 'LFT';
  return items.map(item => {
    var _queryParam;
    var itemCode = isSRHotelFilter(item) ? item.code : item.codes;
    var itemName = isSRHotelFilter(item) ? item.name : item.label;
    var selectedDlpFiltersCodes = selectedFilters.map(filter => filter.codes);
    return _jsx(Checkbox, {
      my: "xs",
      value: itemCode,
      "aria-label": itemName,
      isChecked: isDlp ? selectedDlpFiltersCodes.some(filterCodes => {
        if (filterCodes.length > 1) {
          return filterCodes.some(filter => {
            return itemCode === null || itemCode === void 0 ? void 0 : itemCode.includes(filter);
          });
        }
        return filterCodes[0] === itemCode;
      }) : selectedFilters.some(filterCode => filterCode === itemCode),
      "data-testid": formatDataTestId(baseDataTestId, "Filters-checkbox-".concat(itemCode)),
      "data-query-param": (_queryParam = item.queryParam) !== null && _queryParam !== void 0 ? _queryParam : '',
      onChange: handleFilterChange,
      children: itemCode === LIFT_ACCESS_CODE ? _jsxs(Flex, {
        direction: "row",
        display: "inline-flex",
        children: [_jsx(Text, _objectSpread(_objectSpread({}, labelTypography), {}, {
          children: itemName
        })), _jsx(Tooltip, _objectSpread(_objectSpread({
          description: liftInfoMessage,
          variant: "facilities",
          placement: "bottom-start",
          position: "relative",
          alertElementStyles: alertStyles,
          "data-testid": formatDataTestId(baseDataTestId, 'Filters-Lift-access-info-tooltip')
        }, tooltipStyles), {}, {
          children: _jsx(Text, {
            as: "div",
            role: "img",
            tabIndex: 0,
            "aria-label": liftInfoMessage,
            "data-testid": formatDataTestId(baseDataTestId, 'Filters-Lift-access-info-icon'),
            children: _jsx(Icon, {
              ml: "sm",
              mt: "xs",
              svg: _jsx(Info, {})
            })
          })
        }))]
      }) : _jsx(Text, _objectSpread(_objectSpread({}, labelTypography), {}, {
        children: itemName
      }))
    }, itemCode);
  });
}
var alertStyles = {
  py: 'sm',
  padding: 0,
  w: '11.625rem',
  h: '6.125rem'
};
var tooltipStyles = {
  marginLeft: '-1rem',
  fontSize: 'sm',
  lineHeight: '2',
  paddingLeft: 0,
  fontWeight: 'normal',
  top: 'xs'
};